<script setup lang="ts">
import {
  Download as DownloadIcon,
  Eye as EyeIcon,
  EyeOff as EyeOffIcon,
  PenLine as PenLineIcon,
  Pin as PinIcon,
  PinOff as PinOffIcon,
  SquarePlus as SquarePlusIcon,
  Trash2 as Trash2Icon,
} from '@lucide/vue'
import { computed } from 'vue'

import type { ActionMenuDensity, ActionMenuItem } from '@/components/ui/actionMenu'
import ActionMenuList from '@/components/ui/ActionMenuList.vue'

defineOptions({ name: 'WorkspacePOIActionSheetContent' })

const props = withDefaults(
  defineProps<{
    isPinnedWorkspace: boolean
    isPinned: boolean
    isVisible: boolean
    canEdit: boolean
    canDelete: boolean
    density?: ActionMenuDensity
  }>(),
  { density: 'comfortable', isPinned: false },
)

const emit = defineEmits<{
  togglePinned: []
  toggleVisibility: []
  download: []
  addToCollection: []
  rename: []
  delete: []
}>()

const actionItems = computed<ActionMenuItem[]>(() => {
  const items: ActionMenuItem[] = [
    {
      key: 'toggle-pinned',
      label: props.isPinned ? 'Unpin' : 'Pin',
      icon: props.isPinned ? PinOffIcon : PinIcon,
      iconClass: props.isPinned ? 'text-amber-600' : 'text-gray-400',
      onSelect: () => emit('togglePinned'),
    },
  ]

  items.push(
    {
      key: 'toggle-visibility',
      label: props.isVisible ? 'Hide' : 'Unhide',
      icon: props.isVisible ? EyeOffIcon : EyeIcon,
      onSelect: () => emit('toggleVisibility'),
    },
    {
      key: 'download',
      label: 'Download GPX',
      icon: DownloadIcon,
      onSelect: () => emit('download'),
    },
  )

  items.push({
    key: 'add-to-collection',
    label: 'Add to collection',
    icon: SquarePlusIcon,
    onSelect: () => emit('addToCollection'),
  })

  if (props.canEdit) {
    items.push({
      key: 'rename',
      label: 'Rename',
      icon: PenLineIcon,
      onSelect: () => emit('rename'),
    })
  }

  if (props.canDelete && !props.isPinnedWorkspace) {
    items.push({
      key: 'delete',
      label: 'Delete',
      icon: Trash2Icon,
      danger: true,
      separated: true,
      onSelect: () => emit('delete'),
    })
  }

  return items
})
</script>

<template>
  <ActionMenuList :items="actionItems" :density="density" />
</template>
